<!-- ChoicePatientName.vue -->
<script lang="ts" setup>
    import * as ChoiceEntityUtils from "../lib/ChoiceEntityUtils"
    import * as DateUtils from "../lib/DateUtils"
    import { IChoiceEntity } from "../lib/ChoiceEntityUtils";
    import { IEntityInfoById } from '../lib/Models/EntityModel';
    import { computed } from 'vue';
    import MessageText from "./Messages/MessageText.vue";
    import { DisplayStyle } from "../Enums/UiEnums";


    const props = withDefaults(defineProps<{
            patientEntity?: IChoiceEntity | IEntityInfoById,
            showDOB?: boolean,
            showAge?: boolean,
            showGender?: boolean
        }>(), {
            showDOB: true,
            showAge: true,
            showGender: true
    });

    const choiceEntity = computed<IChoiceEntity | undefined>(() => {
        if (!props.patientEntity)
            return;

        if ((<IChoiceEntity>props.patientEntity)?.entity_id)
            return <IChoiceEntity>props.patientEntity;

        if ((<IEntityInfoById>props.patientEntity).entityId)
        {
            const entityInfo = <IEntityInfoById>props.patientEntity;
            return {
                entity_id: (entityInfo.entityId ?? -1),

                first_name: entityInfo.firstName,
                last_name: entityInfo.lastName,
                middle_name: entityInfo.middleName,

                birth_date: entityInfo.birthDate,
                date_of_death: entityInfo.dateOfDeath,

                gender_code: entityInfo.genderCode
            } as IChoiceEntity;
        }
    });

</script>

<template>
    <span v-if="choiceEntity">
        <span class="pe-2">
            {{ChoiceEntityUtils.formatName(choiceEntity)}}
        </span>

        <span v-if="showDOB && choiceEntity.birth_date" title="Date of Birth">
            <small class="text-muted">Born:</small>

            {{DateUtils.prettyDate(choiceEntity.birth_date)}}
        </span>
        <span v-if="showAge && choiceEntity.birth_date" title="Age">
            ({{ChoiceEntityUtils.age(choiceEntity)}}y)
        </span>

        <span v-if="showGender" title="Gender" class="pb-2">
            <small class="text-muted">
                Gender: 
            </small>

            {{ChoiceEntityUtils.genderDesc(choiceEntity)}}
        </span>
    </span>

    <span v-if="!choiceEntity">
        <slot name="BadEntity">
            <MessageText :displayStyle="DisplayStyle.Danger">n/a</MessageText>
        </slot>
    </span>
    
</template>